import React, {useMemo} from 'react'
import {connect} from "react-redux";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";


const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        stripePublicKey: state.billing.stripePublicKey,
    }
};

const StripeWrapper = ({stripePublicKey, children}) => {
    const stripePromise = useMemo(() => stripePublicKey ? loadStripe(stripePublicKey) : null, [stripePublicKey]);

    if (!stripePublicKey) {
        console.error("No stripePublicKey");
        return <div></div>;
    }

    return (
        <Elements stripe={stripePromise}>
            <>{children}</>
        </Elements>
    );
};

export default connect(mapStateToProps)(StripeWrapper);